export default "/images/719a1eb628cfc8e57c8e5af4343afc12.avif";